const nt = {
  id: 'sealink_nt',
  name: 'SeaLink NT',
  quicktravelUrl: 'https://nt-current.quicktravel.com.au',
  productTypeIDs: [30, 31], // 30=NT Ferry & Bus 31=NT Kiosk
  adjustmentCategoryId: 13, // ID of category of adjustments to show
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 6, code: 'eftpos' },
      { id: 7, code: 'cheque' },
      { id: 9, code: 'amex' },
      { id: 13, code: 'on_account' },
      { id: 19, code: 'mastercard_visa' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14, 74, 81, 232, 158],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: '655d5bcd5bedfb3ddfd2dbd16af950b348a4e5cd16ba897707af059b5fde4623',
};

const qld = {
  id: 'sealink_nq',
  name: 'SeaLink NQ',
  quicktravelUrl: 'https://nq-current.quicktravel.com.au',
  productTypeIDs: [26, 27, 16, 29], // These are the ids of the Palm Is and Maggi Is product types in QT
  adjustmentCategoryId: 1, // ID of category of adjustments to show
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 5, code: 'tcc_voucher' },
      { id: 6, code: 'eftpos' },
      { id: 7, code: 'cheque' },
      { id: 9, code: 'amex' },
      { id: 13, code: 'on_account' },
      { id: 19, code: 'mastercard_visa' },
      { id: 48, code: 'tsv' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14, 74, 81, 232, 158],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: '655d5bcd5bedfb3ddfd2dbd16af950b348a4e5cd16ba897707af059b5fde4623',
};

const ccc = {
  id: 'captain_cook',
  name: 'Captain Cook NSW',
  quicktravelUrl: 'https://cc-current.quicktravel.com.au',
  productTypeIDs: [10, 17, 14],
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 4, code: 'on_account' },
      { id: 8, code: 'amex' },
      { id: 11, code: 'mastercard_visa' },
      { id: 13, code: 'on_account' },
      { id: 17, code: 'diners' },
      { id: 18, code: 'jcb' },
      { id: 20, code: 'eftpos' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: 'd9217eb7352eb204849602f304f230c7c5ad793dff8672fd9ff8002a57b3b610',
};

export default {
  tenants: [nt, qld, ccc],
  printingEnabled: true,
  debugEvents: false,
  rollbar: {
    accessToken: '244053c716364af1a39217cb3cafae96',
    enabled: true,
    environment: 'current',
  },
  datadog: {
    applicationId: 'ac90443c-2836-4ed2-8a7e-9a0dad22c441',
    clientToken: 'pubfaeb9fcfacb936e85c3ef987ef0b5411',
    environment: 'prod',
    service: 'quicktickets-web-current',
  },
  authServiceURL: 'https://auth-next.quicktravel.com.au',
  gitSha: null,
  showEnv: true,
  environment: 'current',
  guestLinkURL: 'https://guestlink-next.quicktravel.com.au',
  oktaIssuer: 'https://kelsian.okta.com/oauth2/aus2r719unt8dKcPH697',
  oktaClientId: '0oa4d13vlvKBQXPsI697',
  oktaAppBase: 'https://quicktickets-web-current.quicktravel.com.au',
  oktaEnabled: true,
  googleTagManagerId: 'G-HHSRR0C3KY',
};
